module.exports = __webpack_public_path__ + "img/character-cat-normal.a6c35282.svg";